import { Stack, Typography } from "@mui/material"
import Section from "./Section"

function Bloc({ title, desc }: { title: string; desc: string }) {
  return (
    <Stack
      sx={{
        flex: 1,
        p: 1.5,
        borderRadius: "12px",
        background: "rgba(255, 255, 255, 0.02)",
        border: "1px solid rgba(255, 255, 255, 0.03)",
      }}
    >
      <Typography
        variant="h6"
        sx={{ pt: 1, pb: 1 }}
        fontWeight="bold"
        align="left"
      >
        {title}
      </Typography>
      <Typography color="rgb(154, 167, 180)" align="left">
        {desc}
      </Typography>
    </Stack>
  )
}

export interface NextStepsProps {
  phone: boolean
}
export default function NextSteps({ phone }: NextStepsProps) {
  return (
    <Section>
      <Stack sx={{ width: "100%" }} alignItems="start" spacing={2}>
        <Typography fontWeight="bold" fontSize={34} sx={{ p: 1 }}>
          Comment passer à l'action ?
        </Typography>
        <Stack direction={phone ? "column" : "row"} spacing={2}>
          <Bloc
            title="1. Découverte et démo"
            desc="Un premier échange d'une heure pour comprendre vos besoins et vous présenter notre offre."
          />
          <Bloc
            title="2. Audit"
            desc="Nous analysons vos données de production pour évaluer les gains de productivité que vous pourriez réaliser."
          />
          <Bloc
            title="3. Démarrage du projet"
            desc="Nous déployons notre logiciel dans votre entrepôt ou bien nous menons une action de conseil ponctuelle."
          />
        </Stack>
      </Stack>
    </Section>
  )
}
